import { Colors } from '@sigma-frontend-libs/commons'

import { buttonModes, components, icons, isHEX, labelModes } from '@/utils'

import button from '@/components/button'
import squircle from '@/components/icon/squircle'
import arrow from '@/components/misc/arrow'
import sticker from '@/components/sticker'

const defaultColors = {
  primary: '#1976D2',
  secondary: '#FFA726',
  accent: '#82B1FF',
  error: '#FF5252',
  info: '#2196F3',
  success: '#4CAF50',
  warning: '#FFC107'
}

function renderHeaderContent(h, options) {
  const { path, serviceName } = options

  return h(
    'div',
    {
      class: 'faic grid-gap--8'
    },
    [
      h(
        squircle,
        {
          props: {
            icon: icons.color_lens,
            color: Colors.grey
          }
        }
      ),
      this.getTranslate(`${serviceName}.subtitles.${path}`)
    ]
  )
}
function renderHeader(h, options, expanded) {
  return h(
    'div',
    {
      class: 'default-expansion-panel-header pl-2'
    },
    [
      renderHeaderContent.call(this, h, options),
      h(arrow, { props: { expanded } })
    ]
  )
}

function renderSticker(h, options, color) {
  const { path, serviceName } = options

  return h(
    sticker,
    {
      props: {
        label: this.getTranslate(`${serviceName}.labels.${path}.${color}`),
        value: this.proxy[color],
        color,
        icon: icons.color_lens,
        copy: true
      }
    }
  )
}

function renderInput(h, options, color) {
  const { path, serviceName } = options

  let inputError
  if (!isHEX(this.proxy[color])) {
    inputError = this.getTranslate('commons.errors.hex')
  }

  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy[color],
        label: this.getTranslate(`${serviceName}.labels.${path}.${color}`),
        defaultValue: defaultColors[color],
        error: inputError,
        labelMode: labelModes.hidden,
        flat: true,
        dense: true,
        clearable: true,
        details: false
      },
      on: {
        input: event => {
          this.proxy[color] = event
        }
      }
    }
  )
}
function renderItem(h, options, color) {
  return h(
    'div',
    {
      class: 'grid grid-gap--8',
      style: { gridTemplateColumns: '180px 1fr' }
    },
    [
      renderSticker.call(this, h, options, color),
      renderInput.call(this, h, options, color)
    ]
  )
}
function renderItems(h, options) {
  return Object.keys(this.proxy).map(item => {
    return renderItem.call(this, h, options, item)
  })
}
function renderBody(h, options) {
  return h(
    'div',
    {
      class: 'grid grid-gap--8 pt-2 px-2'
    },
    [ renderItems.call(this, h, options) ]
  )
}
function renderFooter(h) {
  return h(
    'div',
    {
      class: 'dialog__footer'
    },
    [
      h(
        button,
        {
          props: {
            icon: icons.save,
            color: Colors.primary,
            mode: buttonModes.flat,
            label: this.getTranslate('misc.buttons.save'),
            loading: this.loading,
            disabled: this.disabled
          },
          on: {
            click: () => {
              this.submit()
            }
          }
        }
      )
    ]
  )
}
function renderContent(h, options) {
  return h(
    'div',
    {
      class: 'grid grid-gap--0'
    },
    [
      renderBody.call(this, h, options),
      renderFooter.call(this, h)
    ]
  )
}

export default function(h, options) {
  return h(
    components['expansion-panel'],
    {
      props: {
        outline: true,
        rounded: true
      },
      scopedSlots: {
        header: ({ expanded }) => {
          return renderHeader.call(this, h, options, expanded)
        },
        default: () => {
          return renderContent.call(this, h, options)
        }
      }
    }
  )
}
